// Libs
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import cx from 'classnames';

// Components
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import ResultIcon from 'COMPONENTS/ResultIcon';
import Support from 'COMPONENTS/Support';

// Utils
import useTranslator from 'UTILS/hooks/useTranslator';
import {
  LEVEL_COLORS,
  SUCCESS_LEVEL,
  NARROW_LAYOUT,
} from 'UTILS/constants';
import { navigatorDetails } from 'UTILS/navigator';
import { onTrackedClick } from 'UTILS/callbacks';
import { CHECK_RESULT_MAP, CHECK_TRANSLATION_MAP } from 'CHECKS';
import translations from './locales.json';

const ResultBanner = ({ resultList, checkLabel }) => {
  const isSmallScreen = useSelector(state => state.app.layout === NARROW_LAYOUT);
  const [isSupportOpen, setIsSupportOpen] = useState(false);
  const currentWorstResult = resultList.reduce((currentWorstResult, currentResult) => {
    return (currentWorstResult.type > currentResult.type) ? currentWorstResult : currentResult;
  });
  const [translate] = useTranslator(translations);
  const [translateResults] = useTranslator(CHECK_TRANSLATION_MAP[checkLabel]);
  const { type, level, data } = currentWorstResult;
  const { message, title, hintList } = CHECK_RESULT_MAP[type];

  const handleSupportClose = () => {
    setIsSupportOpen(false);
    onTrackedClick('close_support', checkLabel);
  };

  const handleSupportOpen = () => {
    setIsSupportOpen(true);
    onTrackedClick('open_support', checkLabel);
  };

  const buttonClasses = cx('resultBanner-button', {
    'resultBanner-button_right': !isSmallScreen,
  });

  return (
    <>
      {level > SUCCESS_LEVEL && (
        <Support
          open={isSupportOpen}
          onClose={handleSupportClose}
          title={title}
          hintList={hintList}
          checkLabel={checkLabel}
          data={data}
        />
      )}
      <Box bgcolor={`${LEVEL_COLORS[level]}.light`} className={isSmallScreen ? 'resultBanner-container' : 'resultBanner-container_oneLineContained'}>
        <Box className={isSmallScreen ? 'resultBanner-logoAndMessage' : 'resultBanner-logoAndMessage_alignLogoAndMessage'}>
          <Box className='resultBanner-icon'>
            <ResultIcon resultLevel={level} />
          </Box>
          <Typography variant='body2'>{translateResults(message, { ...currentWorstResult.data, ...navigatorDetails })}</Typography>
        </Box>
        {level !== SUCCESS_LEVEL && (
          <Box className={buttonClasses} >
            <Button onClick={handleSupportOpen} color='primary' variant='contained'>{translate('helpAndSupport')}</Button>
          </Box>
        )}
      </Box>
    </>
  );
};

export default ResultBanner;
